import React, { useEffect, useState } from "react";

export const FuturePopup = () => {
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    let t;
    const proto = document.querySelector("[data-testid=protocol-section]");
    const target = document.querySelector("[data-testid=closing-section]");
    const seen = new IntersectionObserver(([e]) => { if (e.isIntersecting) t = setTimeout(() => setShow(true), 1200); }, { threshold: 0.15 });
    const obs = new IntersectionObserver(([e]) => e.isIntersecting && setClosed(true), { threshold: 0.35 });
    if (proto) seen.observe(proto);
    if (target) obs.observe(target);
    return () => {
      clearTimeout(t);
      seen.disconnect();
      obs.disconnect();
    };
  }, []);

  const go = () => {
    document.getElementById("keep-going")?.scrollIntoView({ behavior: "smooth", block: "center" });
    setClosed(true);
  };

  if (!show || closed) return null;
  return (
    <div className="future-pop" data-testid="future-popup">
      <button className="future-pop-btn" onClick={go} data-testid="future-popup-btn">
        <span className="future-pop-dot" />
        Rehearse your future self with guided audio
        <span aria-hidden="true">&darr;</span>
      </button>
      <button className="future-pop-x" onClick={() => setClosed(true)} aria-label="Dismiss" data-testid="future-popup-close">&times;</button>
    </div>
  );
};
